import { Filter } from '../../../hooks/useDrawerFilter';

export function isFilterSelected(currentFilters: Filter[], filter: Filter) {
  return currentFilters.some(
    currentFilter => currentFilter.value === filter.value,
  );
}
